import TopNavigation from '../../components/bar/TopNavigation';

export default function CenterScreenWrapper({
  children,
  onBackClick,
  topNavigationTitle
}: {
  children: React.ReactNode;
  onBackClick?: () => void;
  topNavigationTitle?: string;
}) {
  const type = onBackClick ? 'back' : undefined;

  return (
    <div className="pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] h-screen dark:bg-background-dark bg-background-light flex flex-col">
      <TopNavigation
        type={type}
        centerComponent={
          topNavigationTitle && (
            <p className="text-pure-black text-[17px] font-bold dark:text-main-dark-1 flex-shrink-0">
              {topNavigationTitle}
            </p>
          )
        }
        onBackClick={onBackClick}
      />
      <div className="flex flex-col justify-center gap-[30px] flex-1 min-h-0">{children}</div>
    </div>
  );
}
